/**
 * Heartbeat service – interval 5 detik sesuai spesifikasi.
 */

import { postWebosHeartbeat } from '../repository.js';

export function startHeartbeat(token, { intervalMs = 5000, onUnauthorized } = {}) {
  let stopped = false;
  let inFlight = false;

  const tick = async () => {
    if (stopped || inFlight) return;
    inFlight = true;
    try {
      const res = await postWebosHeartbeat(token);
      if (!res.ok && (res.status === 401 || res.status === 403)) {
        try {
          onUnauthorized?.(res);
        } catch {}
      }
    } catch {
      // ignore network errors; next tick will retry
    } finally {
      inFlight = false;
    }
  };

  // fire immediately, then interval
  tick();
  const id = setInterval(tick, Math.max(1000, Number(intervalMs) || 5000));

  return () => {
    stopped = true;
    clearInterval(id);
  };
}
